/**
 * TanStack Query hooks for `click-level-detail-reports`. Thin wrappers over ./api.
 * List query key carries the entire `ListClicksFilters` so a filter change
 * triggers an automatic refetch (keyed by date-range + campaign + country).
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	clickLevelDetailReportsQueryKeys,
	getStats,
	listClicks,
	type ListClicksFilters,
	type ListClicksResponse,
	type StatsResponse,
} from "./api";

export function useClickLevelDetailReportsQuery(
	filters: ListClicksFilters,
): UseQueryResult<ListClicksResponse, Error> {
	return useQuery({
		queryKey: clickLevelDetailReportsQueryKeys.list(filters),
		queryFn: () => listClicks(filters),
	});
}

export function useClickLevelDetailReportsStats(): UseQueryResult<StatsResponse, Error> {
	return useQuery({
		queryKey: clickLevelDetailReportsQueryKeys.stats(),
		queryFn: getStats,
	});
}
